import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Landing from "../Landing-screen/Landing.js";
import { getUserHomeData } from "../../Public/user-home-data.js";
import { ButtonPrimary, ButtonSecondary } from "../../Utils/Buttons/button-component";

const UserWelcomeBanner = () => {
    const navigate = useNavigate();
    const { user, isAuthenticated } = useSelector((state) => state.auth);
    const { language = 'en' } = useSelector((state) => state.systemData || {});
    const t = useMemo(() => getUserHomeData(language), [language]);

    if (!isAuthenticated) return null;

    const firstName = user?.name?.split(' ')[0] || user?.email?.split('@')[0] || '';

    return (
        <div className="w-full bg-primary-500 border-b border-white/10 py-3.5">
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between gap-4">
                
                {/* --- Left: Simple Identity --- */}
                <div className="flex items-center gap-3">
                    <div className="flex items-center gap-1.5 overflow-hidden">
                        <span className="text-[10px] uppercase tracking-widest text-white/40 whitespace-nowrap">
                            {t.hero.greeting}
                        </span>
                        <span className="text-[11px] font-bold text-white uppercase tracking-wider truncate">
                            {firstName}
                        </span>
                    </div>
                </div>

                {/* --- Right: System Buttons --- */}
                <div className="flex items-center gap-2.5 shrink-0">
                    <ButtonSecondary
                        onClick={() => navigate('/account')}
                        size="md"
                    >
                        {t.quickActions.orders.label}
                    </ButtonSecondary>
                    
                    <ButtonPrimary
                        onClick={() => navigate('/shop')}
                        size="md"
                    >
                        {t.quickActions.shop.label}
                    </ButtonPrimary>
                </div>

            </div>
        </div>
    );
};

function Home() {
    return <Landing topBanner={<UserWelcomeBanner />} />;
}

export default Home;